module.exports = __webpack_public_path__ + "media/app/assets/races/dwarf_female-2be42ef34fdcfad5468fe1f2ac38f63c.png";